import { FromJSONable } from "./FromJSONable";
import { Departure } from "./departure";
import { TrainStop } from "./trainstop";

export class Trip implements FromJSONable{
    id_src:TrainStop;
    id_dst:TrainStop;
    start:Date;
    startStr:string;
    constructor(id_src:number=0,id_dst:number=0,start:Date){
        this.id_src=new TrainStop();
        this.id_dst=new TrainStop();
        this.start = start;
        this.startStr = this.convertDateToString(start);
    }
    parseJSONObject(object:Object){
        if(!object){return;}
        Object.assign(this,object);
    }

    private convertDateToString(date : Date):string{

        try{
            return date.getFullYear() + "-" + (date.getMonth()+1)+ "-" + date.getDate();
        }
        catch{return "";}

    }

}